import React, { useEffect, useState } from 'react'
import Chart from '../../../../../components/Rechart/Chart';
import http from '../../../../../config/BaseUrl';

function FacebookShare({eventId}) {

  const facebookData = {
    weeklyData: [
      { name: 'Day 1', share: 10, pv: 2400, amt: 2400 },
      { name: 'Day 2', share: 25, pv: 2400, amt: 2400 },
      { name: 'Day 3', share: 15, pv: 2400, amt: 2400 },
      { name: 'Day 4', share: 30, pv: 2400, amt: 2400 },
      { name: 'Day 5', share: 30, pv: 2400, amt: 2400 },
      { name: 'Day 6', share: 30, pv: 2400, amt: 2400 },
      { name: 'Day 7', share: 30, pv: 2400, amt: 2400 }
    ],
    monthlyData: [
      { name: 'Week 1', share: 25, pv: 2400, amt: 2400 },
      { name: 'Week 2', share: 50, pv: 2400, amt: 2400 },
      { name: 'Week 3', share: 18, pv: 2400, amt: 2400 },
      { name: 'Week 4', share: 55, pv: 2400, amt: 2400 },
    ],
    yearlyData: [
      { name: 'M 1', share: 100, pv: 2400, amt: 2400 },
      { name: 'M 2', share: 250, pv: 2400, amt: 2400 },
      { name: 'M 3', share: 150, pv: 2400, amt: 2400 },
      { name: 'M 4', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 5', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 6', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 7', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 8', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 9', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 10', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 11', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 12', share: 300, pv: 2400, amt: 2400 }
    ]
  }

  const [isLoading, setIsLoading] = useState(false);
  const [eventGraph, setEventGraph] = useState("");

  const fetchGraphData = async () => {
    try {
      setIsLoading(true)
      await http.get(`event-graph/sharing/${'facebook'}/${eventId}`).then( res =>{
         if(res.data.graphData){
          setIsLoading(false)
          setEventGraph(res.data.graphData)
         }
          
       
      }).catch((err) => {
        console.log('fail');
        setIsLoading(false)
      })
    } catch (error) {
      
    }
  }

  const graphTotalText = {
    week: `This Week`,
    month: 'This Month',
    year: 'This Year'
  }

  useEffect(()=>{
    fetchGraphData()
  }, [])

  return (
    <Chart 
      loading={isLoading}
      graphTotalText={graphTotalText}
      sectionTitle={"Facebook"} 
      sectionName={"facebook"} 
      dataSet={eventGraph} 
      width={330} 
      height={180} 
      dataKey={"share"} 
    />
  )
}

export default FacebookShare
